var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    {
      ref: "tableContainer",
      staticClass: "width-100 relative",
      attrs: { flat: "" },
    },
    [
      _c("v-card-text", [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "d-flex mb-2 justify-center",
              staticStyle: { border: "1px solid #d2d2d2" },
            },
            [
              _c("h2", { staticClass: "text-center" }, [
                _vm._v("Circuit Diagram"),
              ]),
            ]
          ),
          _c("div", {
            staticClass: "gojs-panel d-flex justify-center mt-4",
            staticStyle: { "min-height": "500px" },
            attrs: { id: "gojsPanel" },
          }),
          _vm.selectedCap
            ? _c(
                "div",
                { staticClass: "mt-6" },
                [
                  _c("CapsDetailsFormComponent", {
                    attrs: {
                      "selected-cap": _vm.selectedCap,
                      "location-id": _vm.locationId,
                      readonly: !_vm.hasCircuitEditPermission || _vm.readonly,
                    },
                    on: {
                      "cap-created": _vm.onCapCreated,
                      "cap-updated": _vm.onCapUpdated,
                      "form-reset": _vm.onFormReset,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.selectedPin
            ? _c(
                "div",
                { staticClass: "mt-6" },
                [
                  _c("PinDetailsFormComponent", {
                    attrs: {
                      "selected-location-id": _vm.locationId,
                      "selected-pin": _vm.selectedPin,
                      readonly: !_vm.hasCircuitEditPermission || _vm.readonly,
                    },
                    on: {
                      "pin-created": _vm.onPinCreated,
                      "pin-updated": _vm.onPinUpdated,
                      "form-reset": _vm.onPinFormReset,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }